module.exports = __webpack_public_path__ + "static/img/uplatauloga1.9aef250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/uplatauloga1.png
// module id = PhHo
// module chunks = 0